var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHwaIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 322.221,
    height: 93.579,
    viewBox: "0 0 322.221 93.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HWA_Illustration",
    "data-name": "HWA Illustration",
    transform: "translate(-6.389 -3.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219500",
    "data-name": "Path 219500",
    d: "M6.5,48.228l.978,11.931a28.16,28.16,0,0,0,11.99,20.823h0a28.165,28.165,0,0,0,26.982,2.847L71.523,73.305A16.865,16.865,0,0,1,91.77,79.047h0a30.357,30.357,0,0,0,19.25,12.211l13.227,2.413a105.011,105.011,0,0,0,38.567-.164l71.079-13.589a109.723,109.723,0,0,1,26.219-1.81h0A75.834,75.834,0,0,0,314.976,58.5l8.11-7.369a16.865,16.865,0,0,0,.726-24.265h0a16.866,16.866,0,0,0-14.226-4.945l-14.895,1.923a16.865,16.865,0,0,1-16.8-8.362h0a22.447,22.447,0,0,0-29.62-8.9l-9.835,4.973a47.012,47.012,0,0,1-25.464,4.865L131.829,9.054a16.879,16.879,0,0,0-8.5,1.439L91.383,25a16.867,16.867,0,0,1-14.611-.321l-17.6-8.94a38.035,38.035,0,0,0-35.18.379h0A33.338,33.338,0,0,0,6.5,48.228Z",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5634",
    "data-name": "Group 5634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5611",
    "data-name": "Group 5611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219501",
    "data-name": "Path 219501",
    d: "M244.228,11.368v-3h-3v-3h-54.98V88.947h3v3h3v3h54.98V11.368Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219502",
    "data-name": "Path 219502",
    d: "M241.228,5.368v3h3v3h3V94.947h-54.98v-3h-3v-3h-3V5.368h54.98m0-2h-54.98a2,2,0,0,0-2,2V88.947a2,2,0,0,0,2,2h1v1a2,2,0,0,0,2,2h1v1a2,2,0,0,0,2,2h54.98a2,2,0,0,0,2-2V11.368a2,2,0,0,0-2-2h-1v-1a2,2,0,0,0-2-2h-1v-1a2,2,0,0,0-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5601",
    "data-name": "Group 5601"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22897",
    "data-name": "Rectangle 22897",
    width: 54.98,
    height: 83.579,
    transform: "translate(192.248 11.368)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219503",
    "data-name": "Path 219503",
    d: "M247.228,11.368V94.947h-54.98V11.368h54.98m0-1h-54.98a1,1,0,0,0-1,1V94.947a1,1,0,0,0,1,1h54.98a1,1,0,0,0,1-1V11.368a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5602",
    "data-name": "Group 5602"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22898",
    "data-name": "Rectangle 22898",
    width: 54.98,
    height: 83.579,
    transform: "translate(189.248 8.368)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219504",
    "data-name": "Path 219504",
    d: "M244.228,8.368V91.947h-54.98V8.368h54.98m0-1h-54.98a1,1,0,0,0-1,1V91.947a1,1,0,0,0,1,1h54.98a1,1,0,0,0,1-1V8.368a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5603",
    "data-name": "Group 5603"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22899",
    "data-name": "Rectangle 22899",
    width: 54.98,
    height: 83.579,
    transform: "translate(186.248 5.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219505",
    "data-name": "Path 219505",
    d: "M241.228,5.368V88.947h-54.98V5.368h54.98m0-1h-54.98a1,1,0,0,0-1,1V88.947a1,1,0,0,0,1,1h54.98a1,1,0,0,0,1-1V5.368a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5609",
    "data-name": "Group 5609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5604",
    "data-name": "Group 5604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219506",
    "data-name": "Path 219506",
    d: "M231.625,33.371H204.286a1,1,0,1,1,0-2h27.339a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219507",
    "data-name": "Path 219507",
    d: "M199.738,28.759v6.886h-6.886V28.759h6.886m0-1h-6.886a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V28.759a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5605",
    "data-name": "Group 5605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219508",
    "data-name": "Path 219508",
    d: "M226.625,48.371H204.286a1,1,0,0,1,0-2h22.339a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219509",
    "data-name": "Path 219509",
    d: "M199.738,43.759v6.886h-6.886V43.759h6.886m0-1h-6.886a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V43.759a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22900",
    "data-name": "Rectangle 22900",
    width: 4.886,
    height: 4.886,
    transform: "translate(193.852 44.759)",
    fill: "#1890ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5607",
    "data-name": "Group 5607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219510",
    "data-name": "Path 219510",
    d: "M199.738,58.759v6.886h-6.886V58.759h6.886m0-1h-6.886a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V58.759a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5606",
    "data-name": "Group 5606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219511",
    "data-name": "Path 219511",
    d: "M228.625,61.2H204.286a1,1,0,0,1,0-2h24.339a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219512",
    "data-name": "Path 219512",
    d: "M218.625,65.2H204.286a1,1,0,0,1,0-2h14.339a1,1,0,0,1,0,2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5608",
    "data-name": "Group 5608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219513",
    "data-name": "Path 219513",
    d: "M227.625,78.371H204.286a1,1,0,0,1,0-2h23.339a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219514",
    "data-name": "Path 219514",
    d: "M199.738,73.759v6.886h-6.886V73.759h6.886m0-1h-6.886a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V73.759a1,1,0,0,0-1-1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5610",
    "data-name": "Group 5610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219515",
    "data-name": "Path 219515",
    d: "M203.334,17.878a.675.675,0,0,0-.264-.573,3.4,3.4,0,0,0-.949-.422,6.749,6.749,0,0,1-1.085-.438,1.772,1.772,0,0,1-1.09-1.586,1.545,1.545,0,0,1,.292-.925,1.9,1.9,0,0,1,.84-.635,3.144,3.144,0,0,1,1.228-.229,2.879,2.879,0,0,1,1.221.248,1.942,1.942,0,0,1,.833.7,1.829,1.829,0,0,1,.3,1.028h-1.319a.866.866,0,0,0-.276-.684,1.142,1.142,0,0,0-.778-.243,1.212,1.212,0,0,0-.752.2.646.646,0,0,0-.268.538.619.619,0,0,0,.315.524,3.561,3.561,0,0,0,.924.394,4.019,4.019,0,0,1,1.64.84,1.674,1.674,0,0,1,.514,1.248,1.54,1.54,0,0,1-.629,1.3,2.751,2.751,0,0,1-1.692.473,3.25,3.25,0,0,1-1.344-.271,2.123,2.123,0,0,1-.925-.74,1.894,1.894,0,0,1-.319-1.09h1.323q0,1.059,1.265,1.06a1.232,1.232,0,0,0,.734-.192A.623.623,0,0,0,203.334,17.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219516",
    "data-name": "Path 219516",
    d: "M207.317,18.5h2.8v1.059H206v-6.4h1.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219517",
    "data-name": "Path 219517",
    d: "M215.172,16.783h-2.531V18.5h2.97v1.059h-4.289v-6.4H215.6v1.069h-2.962v1.524h2.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219518",
    "data-name": "Path 219518",
    d: "M220.685,16.783h-2.532V18.5h2.971v1.059h-4.289v-6.4h4.28v1.069h-2.962v1.524h2.532Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219519",
    "data-name": "Path 219519",
    d: "M223.666,17.3v2.254h-1.319v-6.4h2.5a2.882,2.882,0,0,1,1.268.264,1.952,1.952,0,0,1,.842.749,2.092,2.092,0,0,1,.294,1.105,1.841,1.841,0,0,1-.644,1.484,2.685,2.685,0,0,1-1.782.543Zm0-1.069h1.177a1.159,1.159,0,0,0,.8-.246.9.9,0,0,0,.275-.7,1.059,1.059,0,0,0-.277-.76,1.034,1.034,0,0,0-.765-.3h-1.208Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5620",
    "data-name": "Group 5620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5612",
    "data-name": "Group 5612"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22901",
    "data-name": "Rectangle 22901",
    width: 54.98,
    height: 83.579,
    transform: "translate(111.268 5.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219520",
    "data-name": "Path 219520",
    d: "M166.248,5.368V88.947h-54.98V5.368h54.98m0-2h-54.98a2,2,0,0,0-2,2V88.947a2,2,0,0,0,2,2h54.98a2,2,0,0,0,2-2V5.368a2,2,0,0,0-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5613",
    "data-name": "Group 5613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219521",
    "data-name": "Path 219521",
    d: "M121.283,18.238h-2.312l-.439,1.319h-1.4l2.382-6.4h1.221l2.395,6.4h-1.4Zm-1.956-1.068h1.6l-.8-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219522",
    "data-name": "Path 219522",
    d: "M129.2,17.426a2.264,2.264,0,0,1-.762,1.625,2.677,2.677,0,0,1-1.813.594,2.411,2.411,0,0,1-1.936-.829,3.4,3.4,0,0,1-.705-2.274V16.15a3.829,3.829,0,0,1,.325-1.625,2.434,2.434,0,0,1,.93-1.079,2.9,2.9,0,0,1,3.188.218,2.43,2.43,0,0,1,.782,1.665H127.89a1.33,1.33,0,0,0-.346-.9,1.269,1.269,0,0,0-.9-.28,1.12,1.12,0,0,0-.987.473,2.651,2.651,0,0,0-.336,1.466v.482a2.828,2.828,0,0,0,.314,1.517,1.1,1.1,0,0,0,.991.479,1.3,1.3,0,0,0,.912-.279,1.262,1.262,0,0,0,.345-.863Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219523",
    "data-name": "Path 219523",
    d: "M135.2,14.227h-1.96v5.33h-1.319v-5.33h-1.933V13.158H135.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219524",
    "data-name": "Path 219524",
    d: "M137.807,19.557h-1.318v-6.4h1.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219525",
    "data-name": "Path 219525",
    d: "M141.843,17.971l1.45-4.813h1.468l-2.228,6.4h-1.376l-2.219-6.4H140.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219526",
    "data-name": "Path 219526",
    d: "M147.215,19.557H145.9v-6.4h1.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219527",
    "data-name": "Path 219527",
    d: "M153.7,14.227h-1.96v5.33h-1.318v-5.33h-1.934V13.158H153.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219528",
    "data-name": "Path 219528",
    d: "M157.181,16.041l1.331-2.883h1.442l-2.1,4.078v2.321h-1.34V17.236l-2.1-4.078h1.446Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5619",
    "data-name": "Group 5619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5614",
    "data-name": "Group 5614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219529",
    "data-name": "Path 219529",
    d: "M156.644,33.371H129.3a1,1,0,1,1,0-2h27.339a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219530",
    "data-name": "Path 219530",
    d: "M124.758,28.759v6.886h-6.887V28.759h6.887m0-1h-6.887a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.887a1,1,0,0,0,1-1V28.759a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22902",
    "data-name": "Rectangle 22902",
    width: 4.886,
    height: 4.886,
    transform: "translate(118.871 29.759)",
    fill: "#1890ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5615",
    "data-name": "Group 5615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219531",
    "data-name": "Path 219531",
    d: "M151.644,48.371H129.3a1,1,0,0,1,0-2h22.339a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219532",
    "data-name": "Path 219532",
    d: "M124.758,43.759v6.886h-6.887V43.759h6.887m0-1h-6.887a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.887a1,1,0,0,0,1-1V43.759a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5617",
    "data-name": "Group 5617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219533",
    "data-name": "Path 219533",
    d: "M124.758,58.759v6.886h-6.887V58.759h6.887m0-1h-6.887a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.887a1,1,0,0,0,1-1V58.759a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5616",
    "data-name": "Group 5616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219534",
    "data-name": "Path 219534",
    d: "M159.644,63.2H129.3a1,1,0,0,1,0-2h30.339a1,1,0,0,1,0,2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5618",
    "data-name": "Group 5618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219535",
    "data-name": "Path 219535",
    d: "M152.644,78.371H129.3a1,1,0,0,1,0-2h23.339a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219536",
    "data-name": "Path 219536",
    d: "M124.758,73.759v6.886h-6.887V73.759h6.887m0-1h-6.887a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.887a1,1,0,0,0,1-1V73.759a1,1,0,0,0-1-1Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5630",
    "data-name": "Group 5630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5621",
    "data-name": "Group 5621"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22903",
    "data-name": "Rectangle 22903",
    width: 54.98,
    height: 83.579,
    transform: "translate(36.288 5.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219537",
    "data-name": "Path 219537",
    d: "M91.268,5.368V88.947H36.288V5.368h54.98m0-2H36.288a2,2,0,0,0-2,2V88.947a2,2,0,0,0,2,2h54.98a2,2,0,0,0,2-2V5.368a2,2,0,0,0-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5622",
    "data-name": "Group 5622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219538",
    "data-name": "Path 219538",
    d: "M53.985,19.557v-6.4h1.969a3,3,0,0,1,1.51.38A2.66,2.66,0,0,1,58.5,14.619a3.34,3.34,0,0,1,.373,1.594v.294a3.353,3.353,0,0,1-.366,1.587,2.631,2.631,0,0,1-1.035,1.076,3.015,3.015,0,0,1-1.508.387Zm1.319-5.33V18.5h.637a1.43,1.43,0,0,0,1.182-.506,2.279,2.279,0,0,0,.418-1.445v-.339a2.318,2.318,0,0,0-.4-1.479,1.426,1.426,0,0,0-1.182-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219539",
    "data-name": "Path 219539",
    d: "M61.687,19.557H60.368v-6.4h1.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219540",
    "data-name": "Path 219540",
    d: "M67.208,16.783H64.676V18.5h2.971v1.059H63.358v-6.4h4.28v1.069H64.676v1.524h2.532Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219541",
    "data-name": "Path 219541",
    d: "M73.775,14.227h-1.96v5.33H70.5v-5.33H68.563V13.158h5.212Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5629",
    "data-name": "Group 5629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5623",
    "data-name": "Group 5623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219542",
    "data-name": "Path 219542",
    d: "M80.664,48.371H54.325a1,1,0,0,1,0-2H80.664a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219543",
    "data-name": "Path 219543",
    d: "M49.777,43.759v6.886H42.891V43.759h6.886m0-1H42.891a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V43.759a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5625",
    "data-name": "Group 5625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219544",
    "data-name": "Path 219544",
    d: "M49.777,58.759v6.886H42.891V58.759h6.886m0-1H42.891a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V58.759a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5624",
    "data-name": "Group 5624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219545",
    "data-name": "Path 219545",
    d: "M84.664,61.2H54.325a1,1,0,0,1,0-2H84.664a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219546",
    "data-name": "Path 219546",
    d: "M68.664,65.2H54.325a1,1,0,0,1,0-2H68.664a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22904",
    "data-name": "Rectangle 22904",
    width: 4.886,
    height: 4.886,
    transform: "translate(43.891 59.759)",
    fill: "#1890ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5626",
    "data-name": "Group 5626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219547",
    "data-name": "Path 219547",
    d: "M77.664,78.371H54.325a1,1,0,0,1,0-2H77.664a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219548",
    "data-name": "Path 219548",
    d: "M49.777,73.759v6.886H42.891V73.759h6.886m0-1H42.891a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V73.759a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5628",
    "data-name": "Group 5628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219549",
    "data-name": "Path 219549",
    d: "M49.777,28.759v6.886H42.891V28.759h6.886m0-1H42.891a1,1,0,0,0-1,1v6.886a1,1,0,0,0,1,1h6.886a1,1,0,0,0,1-1V28.759a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5627",
    "data-name": "Group 5627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219550",
    "data-name": "Path 219550",
    d: "M84.664,31.2H54.325a1,1,0,0,1,0-2H84.664a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219551",
    "data-name": "Path 219551",
    d: "M78.664,35.2H54.325a1,1,0,0,1,0-2H78.664a1,1,0,0,1,0,2Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5632",
    "data-name": "Group 5632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219552",
    "data-name": "Path 219552",
    d: "M293.588,78.36,247.331,64.185a72.2,72.2,0,0,1-13.795-5.853h0a2.161,2.161,0,0,1,1.061-4.053h0a53.858,53.858,0,0,1,15.427,2.364l45.908,14.068a4,4,0,0,1,2.651,5h0A4,4,0,0,1,293.588,78.36Z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219553",
    "data-name": "Path 219553",
    d: "M250.025,56.643A53.94,53.94,0,0,0,234.6,54.278a2.131,2.131,0,0,0-1.3.412,72.142,72.142,0,0,0,10.838,4.317l15.917,4.708a7.585,7.585,0,0,0,7.8-2.214h0Z",
    fill: "#3ea9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219554",
    "data-name": "Path 219554",
    d: "M253.676,72.3c2.391,0,4.709.791,1.723,4.659a9.084,9.084,0,0,1-3.715,3.119,2.776,2.776,0,0,1-3.371-4.059l2.024-3.342a17.626,17.626,0,0,1,3.339-.377m0-2a19.7,19.7,0,0,0-3.775.425,2,2,0,0,0-1.274.916L246.6,74.983a4.73,4.73,0,0,0-.084,4.827,4.729,4.729,0,0,0,5.887,2.134,11.1,11.1,0,0,0,4.577-3.762c.647-.838,2.616-3.389,1.487-5.688-.715-1.455-2.328-2.193-4.793-2.193Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219555",
    "data-name": "Path 219555",
    d: "M260.321,76.937c2,0,3.931.66,1.438,3.889a7.568,7.568,0,0,1-3.1,2.6,2.316,2.316,0,0,1-2.813-3.387l1.69-2.789a14.692,14.692,0,0,1,2.786-.315m0-2a16.738,16.738,0,0,0-3.222.363,2,2,0,0,0-1.275.915L254.135,79a4.274,4.274,0,0,0-.076,4.363,4.281,4.281,0,0,0,5.321,1.927,9.588,9.588,0,0,0,3.962-3.246c.572-.74,2.31-2.992,1.276-5.1-.657-1.337-2.1-2.015-4.3-2.015Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219556",
    "data-name": "Path 219556",
    d: "M250.337,72.678l-2.024,3.342a2.79,2.79,0,0,0,3.371,4.059A9.084,9.084,0,0,0,255.4,76.96C260.447,70.42,250.337,72.678,250.337,72.678Z",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219557",
    "data-name": "Path 219557",
    d: "M257.535,77.252l-1.69,2.789a2.328,2.328,0,0,0,2.813,3.387,7.568,7.568,0,0,0,3.1-2.6C265.973,75.367,257.535,77.252,257.535,77.252Z",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219558",
    "data-name": "Path 219558",
    d: "M302.184,96.834H273.111a2,2,0,0,1-1.34-.516,34.8,34.8,0,0,1-4.682-5.292h0c-1.264-1.728-2.255-3.106-3.067-4.237-3.1-4.309-3.5-4.863-6.8-7.756-.605-.529-1.267-1.086-1.953-1.662-4.77-4.008-10.707-9-7.865-13.831a5.932,5.932,0,0,1,3.282-2.8,5.877,5.877,0,0,1-1.5-4.963c.474-2.4,2.616-4.016,5.732-4.317a24.961,24.961,0,0,1,6.59-.02c10.025-3.592,11.479-2.971,12.107-2.7,1.128.484,3.359,2.749,10.38,10.538,1.052,1.167,2.046,2.271,2.3,2.524,1.74,1.725,10.634,23.386,10.706,23.587.491,1.369,3.77,5.166,6.605,8.045a2,2,0,0,1-1.424,3.4Zm-28.285-4h23.68c-1.825-2.065-3.771-4.509-4.341-6.1-.974-2.716-8.569-20.315-9.839-22.18-.355-.365-1.087-1.174-2.375-2.6-2.26-2.509-7.386-8.195-8.9-9.44a63.076,63.076,0,0,0-9.857,2.9,2.011,2.011,0,0,1-1.489-.05c-.225-.054-1.526-.308-5.476.073-.472.045-2.024.259-2.191,1.109a2.242,2.242,0,0,0,1.279,2.09c1.417.745,8.25.1,13.742-.977a2,2,0,0,1,2.01.8c1.859,2.594,3.24,4.216,4.35,5.519a14.949,14.949,0,0,1,2.968,4.385,4.425,4.425,0,0,1-.723,4.178,8.043,8.043,0,0,1-10.986,2.1,64.694,64.694,0,0,1-8.782-7.311c-.576-.547-1.016-.967-1.27-1.179-1.388-1.16-2.769-1.786-3.617-1.645-.166.029-.671.116-1.228,1.062-1.128,1.92,3.954,6.191,6.991,8.742.707.594,1.391,1.17,2.015,1.716,3.645,3.194,4.293,4.1,7.408,8.429.808,1.124,1.791,2.493,3.047,4.21h0A32.28,32.28,0,0,0,273.9,92.834Zm-15.813-29.9.181.148c.29.243.8.719,1.455,1.344a61.675,61.675,0,0,0,8.182,6.843,4.023,4.023,0,0,0,5.51-.95,1.651,1.651,0,0,0,.293-.613,12.528,12.528,0,0,0-2.26-3.134c-.952-1.117-2.208-2.593-3.8-4.747A68.213,68.213,0,0,1,258.086,62.933Zm25.361,1.672.032.033Zm-22.633-9.228Zm-.287-.143h0Zm0,0,0,0Zm0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219559",
    "data-name": "Path 219559",
    d: "M234.58,54.279h.017a53.858,53.858,0,0,1,15.427,2.364l45.908,14.068a4,4,0,1,1-2.344,7.649L247.331,64.185a72.2,72.2,0,0,1-13.795-5.853h0a2.161,2.161,0,0,1,1.044-4.053m0-2a4.161,4.161,0,0,0-2.012,7.8A74.419,74.419,0,0,0,246.745,66.1L293,80.272a6,6,0,0,0,7.06-8.546,5.96,5.96,0,0,0-3.544-2.928L250.61,54.731a55.809,55.809,0,0,0-16-2.452Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219560",
    "data-name": "Path 219560",
    d: "M230.919,56.842l-2.389-2.033a.624.624,0,0,1,.38-1.1l3.254-.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219561",
    "data-name": "Path 219561",
    d: "M268.7,89.844a32.524,32.524,0,0,0,4.408,4.99h29.073c-.39-.395-6.17-6.282-7.063-8.772-.925-2.577-9.135-21.754-10.233-22.844s-10.649-12.037-12.061-12.643-11.241,2.962-11.241,2.962-.979-.617-6.475-.087-4.648,5.38-1.652,6.958,15.059-.783,15.059-.783c4.193,5.849,6.16,7.055,7.074,9.452a2.61,2.61,0,0,1-.516,2.353,6.029,6.029,0,0,1-8.248,1.523c-4.1-2.617-8.711-7.389-9.845-8.338-1.635-1.368-5.542-3.99-7.852-.062s5.036,9.141,9.412,12.975S262.592,81.494,268.7,89.844Z",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219562",
    "data-name": "Path 219562",
    d: "M279.722,90.76c-3.8-.1-8.035-3.719-10.967-6.808a24.324,24.324,0,0,0-10.1-6.432l-.194-.064c.026.024.056.049.083.072,4.376,3.835,4.049,3.966,10.16,12.316a32.524,32.524,0,0,0,4.408,4.99h28.124C296.609,91.873,285.177,90.9,279.722,90.76Z",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219563",
    "data-name": "Path 219563",
    d: "M269.688,55.636a81.076,81.076,0,0,1-10.47,3.034,17.991,17.991,0,0,1-7.959-.9,4.53,4.53,0,0,0,2.2,2.634c3,1.579,15.059-.783,15.059-.783,2.25,3.139,3.854,4.936,5,6.3l4.039-1.475Z",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5631",
    "data-name": "Group 5631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22905",
    "data-name": "Rectangle 22905",
    d: "M1.344,0H3.533A1.344,1.344,0,0,1,4.877,1.344V3.686A2.439,2.439,0,0,1,2.439,6.125h0A2.439,2.439,0,0,1,0,3.686V1.344A1.344,1.344,0,0,1,1.344,0Z",
    transform: "matrix(0.661, -0.751, 0.751, 0.661, 250.012, 67.388)",
    fill: "#f9d89d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219564",
    "data-name": "Path 219564",
    d: "M257.553,74.178a.5.5,0,0,1-.374-.832l2.9-3.258a.5.5,0,1,1,.747.664l-2.9,3.258A.5.5,0,0,1,257.553,74.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219565",
    "data-name": "Path 219565",
    d: "M255.835,56.8a5.068,5.068,0,0,0,3.578-3.246l.109-.309a36.178,36.178,0,0,0-4.411.205,6.682,6.682,0,0,0-1.9.448l.406,1.574A1.842,1.842,0,0,0,255.835,56.8Z",
    fill: "#f9d89d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219566",
    "data-name": "Path 219566",
    d: "M269.688,52.868a.512.512,0,0,1-.078-.006.5.5,0,0,1-.416-.572l.4-2.57a.5.5,0,1,1,.987.156l-.4,2.57A.5.5,0,0,1,269.688,52.868Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219567",
    "data-name": "Path 219567",
    d: "M273.167,53.813a.527.527,0,0,1-.078-.005.5.5,0,0,1-.416-.573l.4-2.57a.505.505,0,0,1,.572-.416.5.5,0,0,1,.416.572l-.4,2.571A.5.5,0,0,1,273.167,53.813Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_219568",
    "data-name": "Path 219568",
    d: "M269.123,62.495l26.809,8.215a4,4,0,1,1-2.344,7.65l-26.607-8.154,2.142-7.711m0-2A2,2,0,0,0,267.2,61.96l-2.142,7.711a2,2,0,0,0,1.341,2.448L293,80.272A6,6,0,0,0,296.518,68.8l-26.809-8.215a1.992,1.992,0,0,0-.586-.088Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219569",
    "data-name": "Path 219569",
    d: "M295.932,70.71l-26.809-8.215-2.142,7.711,26.607,8.154a4,4,0,0,0,2.344-7.65Z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219570",
    "data-name": "Path 219570",
    d: "M271.882,63.341h0l-2.759-.846-1.067,3.841h0l-1.075,3.87,2.769.849.087-.351h0a3.56,3.56,0,0,1,4.474-2.451L290.4,73.182a4,4,0,0,0,4.992-2.638Z",
    fill: "#3ea9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219571",
    "data-name": "Path 219571",
    d: "M288.6,68.464c-.005.016-.014.029-.018.045l-.662,2.383-14.847-4.559A1.5,1.5,0,0,0,272.2,69.2l14.924,4.582-.664,2.391,2.865.878c0-.011.01-.019.013-.029l.656-2.359,2.765.85a1.5,1.5,0,0,0,.88-2.868l-2.842-.873.676-2.431Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219572",
    "data-name": "Path 219572",
    d: "M294.181,75.209a1.5,1.5,0,0,1-1.427.305L272.2,69.2a1.5,1.5,0,0,1,.881-2.868l20.558,6.313a1.5,1.5,0,0,1,.547,2.563Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219573",
    "data-name": "Path 219573",
    d: "M272.634,66.266a1.483,1.483,0,0,1,.442.067l14.847,4.559.662-2.383c0-.016.013-.029.018-.045l2.865.878-.676,2.431,2.842.873a1.5,1.5,0,1,1-.88,2.868l-2.765-.85-.656,2.359c0,.01-.009.018-.013.029l-2.865-.878.664-2.391L272.2,69.2a1.5,1.5,0,0,1,.439-2.935m0-1h0a2.5,2.5,0,0,0-.732,4.89l13.993,4.3-.4,1.453a1,1,0,0,0,.671,1.224l2.865.878a.992.992,0,0,0,.293.044,1,1,0,0,0,.917-.6,1.206,1.206,0,0,0,.058-.157l.382-1.373,1.783.548a2.5,2.5,0,0,0,3.124-1.658,2.5,2.5,0,0,0-1.656-3.122l-1.912-.587.415-1.493a1,1,0,0,0-.67-1.224l-2.865-.878a1,1,0,0,0-1.227.6,1.366,1.366,0,0,0-.047.135l-.388,1.394-13.865-4.258a2.481,2.481,0,0,0-.735-.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219574",
    "data-name": "Path 219574",
    d: "M272.634,66.266a1.483,1.483,0,0,1,.442.067l20.558,6.313a1.5,1.5,0,1,1-.88,2.868L272.2,69.2a1.5,1.5,0,0,1,.439-2.935m0-1h0a2.5,2.5,0,0,0-.732,4.89L292.46,76.47a2.5,2.5,0,0,0,3.124-1.658,2.5,2.5,0,0,0-1.656-3.122l-20.559-6.313a2.481,2.481,0,0,0-.735-.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219575",
    "data-name": "Path 219575",
    d: "M318.712,96.834H260.447a1,1,0,0,1,0-2h58.265a1,1,0,0,1,0,2Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwaIllustration);
export default __webpack_public_path__ + "static/media/HWA_Illustration.041e86e2759214162f930c2ea0101edf.svg";
export { ForwardRef as ReactComponent };